import { jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';
import { getDefaultHeight } from '../utils/get-default-height.js';

const ExpandCollapseArrow = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8 8",
    height: getDefaultHeight(svgProps, 8),
    ...svgProps,
    fill: svgProps.fill ?? "none",
    stroke: color ?? svgProps.stroke ?? "currentColor",
    strokeLinecap: "round",
    strokeWidth: "1.5",
    children: /*#__PURE__*/jsx("path", {
      d: "M6 1 3 4l3 3"
    })
  });
};

export { ExpandCollapseArrow };
//# sourceMappingURL=arrow.expand-collapse.js.map
